<template>
	<main-masterpage>
		<scrol-set/>

		<!-- WHY CHOOSE -->
		<section class="why">
			<div class="why__header">
				<!-- <p class="why__label">Why homeowners choose us</p> -->
				<h2>What You Can Count On<span></span></h2>
			</div>

			<div class="why__grid">
				<div class="why__item" v-for="(item, i) in reasons" :key="i">
					<!-- <div class="why__num">{{ String(i + 1).padStart(2, '0') }}</div> -->
					<h3>{{ item.title }}</h3>
					<p>{{ item.text }}</p>
				</div>
			</div>

			<div class="why__proof">
				<figure class="why__quote">
					<div class="why__stars" role="img" aria-label="5 out of 5 stars">★★★★★</div>
					<blockquote class="why__quote-text">&ldquo;{{ testimonial.text }}&rdquo;</blockquote>
					<figcaption class="why__quote-caption">
						<span>— {{ testimonial.author }} · {{ testimonial.project }}</span>
						<span class="why__quote-source">Google review</span>
					</figcaption>
				</figure>

				<div class="why__action">
					<button type="button" class="why__cta" @click="showPopup = true">Schedule Your Complimentary Consultation</button>
					<p class="why__cta-note">In your home · No obligation</p>
				</div>
			</div>

			<transition name="fade">
				<popap-view v-if="showPopup" @close="showPopup = false" />
			</transition>
		</section>
		<portfolio-preview/>
		<our-services/>
		<!-- <client-say/> -->
		 <section class="reviews">
            <GoogleReviews />
         </section>
	</main-masterpage>
</template>

<script>
import GoogleReviews from '@/components/GoogleReviews.vue'
// import ClientSay from '@/components/ClientSay.vue';
import OurServices from '@/components/OurServices.vue';
import ScrolSet from '@/components/ScrolSet.vue';
import PortfolioPreview from '@/components/PortfolioPreview.vue';
import PopapView from '@/components/PopapView.vue';
import MainMasterpage from '@/masterpages/MainMasterpage.vue';
import { useHead } from '@vueuse/head';

export default {
	name: 'HomeView',
	components: { MainMasterpage, ScrolSet, OurServices, GoogleReviews, PortfolioPreview, PopapView },

	data() {
		return {
			ioObserver: null,
			showPopup: false,
			testimonial: {
				text:    'When they opened up the wall they found some old water damage behind the sink… instead of hitting us with a surprise bill they sent photos, gave us a price for the fix that same day, and kept going.',
				author:  'Cruz B.',
				project: 'Kitchen remodel',
			},
			reasons: [
				{
					title: 'Your price, set in writing',
					text:  'Your price is agreed and signed before any work begins. If you decide to change something along the way, you\'ll see the cost and approve it first - never on the final invoice.',
				},
				{
					title: 'One dedicated crew, start to finish',
					text:  'Your project is led by the same crew from demolition to final walkthrough, working with the same licensed electricians and plumbers we trust on every job. No strangers in your home.',
				},
				{
					title: 'A project manager who keeps you informed',
					text:  'One point of contact, regular progress updates and same-day answers. You always know what\'s happening in your home.',
				},
			],
		};
	},

	// useHead вызывается в setup(), чтобы теги снимались при уходе со страницы
	setup() {
		useHead({
			title: 'K&M Remodeling Services | Kitchen & Bathroom Remodeling Charlotte NC',
			meta: [
				{ name: 'description',        content: 'Professional kitchen and bathroom remodeling services in Charlotte, NC. Fixed price, one crew, zero surprises — from demo day to final walkthrough.' },
				{ property: 'og:title',       content: 'K&M Remodeling Services | Charlotte NC' },
				{ property: 'og:description', content: 'Full-service remodeling: kitchens, bathrooms, full home renovations in Charlotte, NC.' },
			],
		});
	},

	mounted() {
		const options = { threshold: 0.12 };
		this.ioObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-visible');
					observer.unobserve(entry.target);
				}
			});
		}, options);

		const targets = this.$el.querySelectorAll('.why__header, .why__item, .why__proof');
		targets.forEach(t => this.ioObserver.observe(t));
	},

	beforeUnmount() {
		if (this.ioObserver) this.ioObserver.disconnect();
	},
};
</script>

<style scoped lang="scss">

// ─── WHY SECTION ─────────────────────────────────────────
.why {
	max-width: 1400px;
	margin: 0 auto;
	padding: 20px 30px 20px;

	@media (max-width: 768px) { padding: 15px 15px; }
}

.why__header {
	margin-bottom: 26px;
	opacity: 0;
	transform: translateY(14px);

	@media (max-width: 768px) { margin-bottom: 0; }
}

.why__label {
	font-size: 12px;
	letter-spacing: 0.09em;
	text-transform: uppercase;
	color: rgba(25, 25, 25, 0.4);
	font-weight: 500;
	margin-bottom: 12px;
}

h2 {
	font-size: 42px;
	font-weight: 500;
	color: #191919;
	margin: 0;
	line-height: 1.1;

	span {
		font-family: 'Pinyon Script', cursive;
		font-size: 64px;
		font-weight: 400;
		color: rgba(25, 25, 25, 0.85);
	}

	@media (max-width: 768px) {
		font-size: 22px;
		span { font-size: 36px; }
	}
}

// ─── GRID ────────────────────────────────────────────────
.why__grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 2px;
	background: rgba(0, 0, 0, 0.07);
	border-radius: 20px;
	overflow: hidden;

	@media (max-width: 900px) { grid-template-columns: 1fr; }
}

.why__item {
	background: #ffffff;
	padding: 30px 26px;
	display: flex;
	flex-direction: column;
	gap: 14px;
	opacity: 0;
	transform: translateY(14px);

	&:first-child { border-radius: 20px 0 0 20px; }
	&:last-child  { border-radius: 0 20px 20px 0; }

	@media (max-width: 900px) {
		&:first-child { border-radius: 20px 20px 0 0; }
		&:last-child  { border-radius: 0 0 20px 20px; }
		padding: 28px 24px;
	}
}

.why__num {
	font-size: 13px;
	font-weight: 700;
	letter-spacing: 0.06em;
	color: #d89e1c;
}

h3 {
	font-size: 18px;
	font-weight: 600;
	color: #191919;
	margin: 0;
	line-height: 1.25;
	@media (max-width: 900px) { font-size: 16px; }
}

p {
	font-size: 14px;
	color: rgba(25, 25, 25, 0.8);
	line-height: 1.7;
	margin: 0;
}

// ─── PROOF STRIP ─────────────────────────────────────────
.why__proof {
	display: grid;
	grid-template-columns: minmax(0, 1fr) auto;
	align-items: center;
	gap: 40px;
	margin-top: 20px;
	padding-top: 22px;
	// border-top: 1px solid rgba(0, 0, 0, 0.08);
	opacity: 0;
	transform: translateY(14px);

	@media (max-width: 900px) {
		grid-template-columns: minmax(0, 1fr);
		gap: 24px;
		margin-top: 15px;
		padding-top: 15px;
	}
}

.why__quote {
	margin: 0;
	max-width: 680px;
	min-width: 0;
}

.why__stars {
	color: #f2a51a;
	font-size: 17px;
	letter-spacing: 2px;
	line-height: 1;
	margin-bottom: 12px;
}

.why__quote-text {
	margin: 0 0 14px;
	font-size: 16px;
	font-style: italic;
	line-height: 1.5;
	color: #191919;
	overflow-wrap: break-word;

	@media (max-width: 900px) { font-size: 14px; }
}

.why__quote-caption {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px 12px;
	font-size: 14px;
	color: #6b6b6b;
}

.why__quote-source {
	font-size: 12px;
	padding: 3px 10px;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 100px;
}

.why__action {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 10px;

	@media (max-width: 900px) { align-items: stretch; }
}

// стили как у .hero__cta в ScrolSet.vue
.why__cta {
	padding: 15px clamp(18px, 5vw, 32px);
	background-color: #d89e1c;
	color: #fff;
	font-size: clamp(13px, 1.4vw, 15px);
	font-weight: 500;
	line-height: 1.3;
	text-align: center;
	white-space: nowrap;
	border-radius: 100px;
	border: none;
	cursor: pointer;
	transition: background-color 0.2s ease, transform 0.15s ease;

	&:hover {
		background-color: #bf8b18;
	}

	&:active {
		transform: translateY(1px);
	}

	&:focus-visible {
		outline: 3px solid rgba(216, 158, 28, 0.5);
		outline-offset: 3px;
	}

	@media (max-width: 900px) {
		width: 100%;
		white-space: normal;
		font-size: 15px;
	}

	@media (max-width: 425px) {
		font-size: 13px;
		padding: 13px 18px;
	}
}

.why__cta-note {
	font-size: 12px;
	color: #6b6b6b;
	line-height: 1.4;

	@media (max-width: 900px) { text-align: center; }
}

// ─── POPUP TRANSITION ────────────────────────────────────
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

// ─── ANIMATIONS ──────────────────────────────────────────
.is-visible {
	animation: fadeUp 600ms cubic-bezier(.22, .9, .4, 1) forwards;
}

.why__item:nth-child(1).is-visible { animation-delay: 100ms; }
.why__item:nth-child(2).is-visible { animation-delay: 220ms; }
.why__item:nth-child(3).is-visible { animation-delay: 340ms; }

@keyframes fadeUp {
	from { opacity: 0; transform: translateY(14px); }
	to   { opacity: 1; transform: translateY(0);    }
}

@media (prefers-reduced-motion: reduce) {
	.why__header, .why__item, .why__proof {
		animation: none !important;
		opacity: 1 !important;
		transform: none !important;
	}
}
</style>